import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AddClientModal.css";
import Sidebar from "./sidebar";

const AddClientModal = () => {
  const navigate = useNavigate();
  const [clientData, setClientData] = useState({
    name: "",
    bin: "",
    phone: "",
    address: "",
    email: "",
    is_individual: false,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setClientData({ ...clientData, [name]: value });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setClientData({ ...clientData, [name]: checked });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}v1/clients`, clientData, {
        headers: {
          'x-api-key': '12345xxa'
        }
      });
      navigate('/ClientsList');  // Навигация на страницу ClientsList после успешного добавления клиента
    } catch (error) {
      console.error("Ошибка при добавлении клиента!", error);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="add-client-modal-container">
      <div className="add-client-modal-sidebar">
        <Sidebar />
      </div>
      <div className="add-client-modal-content-basic">
        <div className="add-client-modal-zagolovok">
          <h2>Добавление клиента</h2>
        </div>
        <div className="add-client-modal">
          <form onSubmit={handleSubmit}>
            <div className="add-client-modal-input-container">
              <label>
                Имя
                <input
                  type="text"
                  placeholder="Имя"
                  name="name"
                  value={clientData.name}
                  onChange={handleInputChange}
                  className="add-client-modal-input-block"
                />
              </label>
              <label>
                БИН
                <input
                  type="text"
                  placeholder="БИН"
                  name="bin"
                  value={clientData.bin}
                  onChange={handleInputChange}
                  className="add-client-modal-input-block"
                />
              </label>
              <label>
                Номер телефона
                <input
                  type="text"
                  placeholder="Номер телефона"
                  name="phone"
                  value={clientData.phone}
                  onChange={handleInputChange}
                  className="add-client-modal-input-block"
                />
              </label>
              <label>
                Адрес
                <input
                  type="text"
                  placeholder="Адрес"
                  name="address"
                  value={clientData.address}
                  onChange={handleInputChange}
                  className="add-client-modal-input-block"
                />
              </label>
              <label>
                Почтовый ящик
                <input
                  type="email"
                  placeholder="Почтовый ящик"
                  name="email"
                  value={clientData.email}
                  onChange={handleInputChange}
                  className="add-client-modal-input-block"
                />
              </label>
              <div className="add-client-modal-checkbox-container">
                <label className="add-client-modal-checkbox-container-block">
                  <input
                    type="checkbox"
                    name="is_individual"
                    checked={clientData.is_individual}
                    onChange={handleCheckboxChange}
                    className="add-client-modal-input-block-checkbox"
                  />
                  Физическое лицо
                </label>
              </div>
              <div className="modal-actions">
                <button type="button" className="add-client-modal-button" onClick={handleCancel}>
                  Отмена
                </button>
                <button type="submit" className="add-client-modal-submit">Добавить</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddClientModal;
